module.exports = __webpack_public_path__ + "img/empty.db0c14fe.png";